export default __webpack_public_path__ + "8b8f90ab0e945b1e795a2ef5985e45a2.ttf";